/**
 * crossFade - change the look of the whole screen, and have the old look
 * fade into the new instead of snapping.
 *
 * The browser's View Transitions do the work: it keeps a picture of the page
 * as it was, runs `change`, and cross-fades the picture into the page as it
 * now is. `ms` is how long (the stylesheet reads it as `--cross-ms`); 0, or a
 * browser without the feature, simply runs `change`.
 *
 * A second cross-fade started while one plays ends the first where it is
 * heading and starts from there - which is why only rare, deliberate moments
 * use this (a change of phase, the alarm), and the frequent ones (Stealth's
 * blue rungs, the danger step) ease the ground itself instead.
 *
 * @param {number} ms - the fade's length; 0 for none
 * @param {() => void} change - writes the new look (synchronously)
 */
export function crossFade(ms, change) {
  const canFade = ms > 0 && typeof document !== 'undefined' && typeof document.startViewTransition === 'function';
  if (!canFade) return change();
  document.documentElement.style.setProperty('--cross-ms', `${ms}ms`);
  const transition = document.startViewTransition(change);
  // A fade cut short by the next one rejects these; that is not an error.
  transition.ready?.catch(() => {});
  transition.finished?.catch(() => {});
}
